export const DUPLICATE_STATUSES = Object.freeze({
  PENDING: 'PENDING',
  IN_REVIEW: 'UNDER_REVIEW',
  RESOLVED: 'KEPT_CURRENT',
  REASSIGNED: 'REASSIGNED',
  REJECTED: 'REJECTED',
  SHARED: 'SHARED',
  INVALID: 'INVALID',
});

export const DUPLICATE_STATUS_META = Object.freeze({
  [DUPLICATE_STATUSES.PENDING]: { label: 'Pendiente', variant: 'warning' },
  [DUPLICATE_STATUSES.IN_REVIEW]: { label: 'En consulta', variant: 'info' },
  [DUPLICATE_STATUSES.RESOLVED]: { label: 'Resuelto', variant: 'success' },
  [DUPLICATE_STATUSES.REASSIGNED]: { label: 'Reasignado', variant: 'success' },
  [DUPLICATE_STATUSES.REJECTED]: { label: 'Rechazado', variant: 'danger' },
  [DUPLICATE_STATUSES.SHARED]: { label: 'Compartido', variant: 'primary' },
  [DUPLICATE_STATUSES.INVALID]: { label: 'No válido', variant: 'neutral' },
});

export const DUPLICATE_RESOLUTIONS = Object.freeze({
  KEEP_CURRENT: 'keep_current',
  REASSIGN: 'reassign',
  SHARE: 'share',
  REJECT: 'reject',
  INVALID: 'invalid',
});
